import {styled} from '@linaria/react';
import React from 'react';

interface Props {
  ratio: `${number}:${number}`;
  className?: string;
  style?: React.CSSProperties;
  dataTestId?: string;
}

const Container = styled.div<{
  heightToWidthRatioPercentage: number;
}>`
  position: relative;
  // eslint-disable-next-line local-rules/css-layout-animation
  transition: padding-bottom 0.5s ease-in-out;
  padding-bottom: ${({heightToWidthRatioPercentage}) =>
    `${heightToWidthRatioPercentage}%`};
  width: 100%;
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const FixedRatioContainer: React.FC<React.PropsWithChildren<Props>> = ({
  ratio,
  children,
  className,
  style,
  dataTestId,
}) => {
  const [width, height] = ratio.split(':').map(Number) as [number, number];
  return (
    <Container
      heightToWidthRatioPercentage={(height / width) * 100}
      className={className}
      style={style}
      data-testid={dataTestId}
    >
      <Content>{children}</Content>
    </Container>
  );
};
